import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchShipmentDetails } from "../APIServices/ShipmentDetails";
import { RootState } from "../store";
import { activateLoading, changeId, changeManagedEquipment, deactivateLoading } from "./GlobalSlice";
export interface ShipmentDetailsState {
  shipmentDetailsStoreData: any;
}

const initialState: ShipmentDetailsState = {
  shipmentDetailsStoreData: null,
};

//Reducers
export const ShipmentDetailsSlice = createSlice({
  name: "shipmentDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getShipmentDetails.fulfilled, (state, action) => {
      if (action?.payload) {
        state.shipmentDetailsStoreData = action?.payload?.getShipmentDetails;
      }
    });
  },
});
//Selectors
export const shipmentDetailsData = (state: RootState) =>
  state.shipmentDetails.shipmentDetailsStoreData;
//Action
export const getShipmentDetails = createAsyncThunk(
  "shipmentDetails/getShipmentDetails",
  async (payload: any, { dispatch }) => {
    dispatch(activateLoading());
    const response = await fetchShipmentDetails(payload?.data);
    if (response?.errors && response?.errors?.length > 0 && payload?.callback) {
      response?.errors?.forEach((err: any) => {
        payload?.callback(err?.message);
      });
      dispatch(deactivateLoading());
      return;
    }
    dispatch(changeId(response?.data?.getShipmentDetails?.shipmentId));
    dispatch(changeManagedEquipment(response?.data?.getShipmentDetails?.managedEquipment));
    dispatch(deactivateLoading());
    return response.data;
  }
);
export default ShipmentDetailsSlice.reducer;
